import { useState } from "react";
import SecondaryButton from "../../../common/secondaryButton";
import { handleDecodeJSON } from "../../../utils/encodeDecodeJson";

// module-level registry persists across mount/unmount cycles during the session
const createdFilesRegistry = {};

const CreateAnswerButton = ({ srNo, disabled, fileExtension }) => {
  const [createdFiles, setCreatedFiles] = useState(createdFilesRegistry);

  const isElectron = window.hubbleAPI?.isKiosk?.() ?? false;
  const hasFile = Boolean(createdFiles[srNo]);

  const handleClick = async () => {
    if (!window?.hubbleAPI?.createAnswer) return;

    const encryptedData = sessionStorage.getItem("candidate_exam_details");
    if (!encryptedData) return;

    const decodedData = await handleDecodeJSON({
      decodeJSON: JSON.parse(encryptedData),
    });

    const examName = decodedData?.configuration?.courseName;
    const candidateRollNo = decodedData?.user?.rollNo;
    if (!examName || !candidateRollNo) return;

    const fileName = `${examName}_${candidateRollNo}_question_${srNo}.${fileExtension}`;
    window.hubbleAPI.createAnswer(fileName);
    createdFilesRegistry[srNo] = fileName;
    setCreatedFiles({ ...createdFilesRegistry });
  };

  if (!isElectron) return null;

  return (
    <SecondaryButton
      color={"rgba(63, 65, 209, 1)"}
      border="1px solid rgba(63, 65, 209, 1)"
      onClick={handleClick}
    //   disabled={disabled}
    >
      {hasFile ? "Edit Answer File" : "Create Answer File"}
    </SecondaryButton>
  );
};

export default CreateAnswerButton;
